module.exports = __webpack_public_path__ + "static/assets/fa138c34d9f258e339df694403861a51.svg";